import { Base64 } from 'js-base64';
import PKCE from 'js-pkce';
import { environments } from '@/environments';
import { removeAccessToken, removeIDToken } from '@/helpers/cookie';
import { RoutesMapping } from '@/helpers/routing';

const TEOD_ENV_NAME = 'teod';

export const initiatePKCE = () => {
  return new PKCE({
    client_id: 'new-backoffice-portal',
    redirect_uri: `${environments.siteUrl}${RoutesMapping.CALLBACK}`,
    authorization_endpoint: `${environments.auth.oAuthUrl}/auth`,
    token_endpoint: `${environments.auth.oAuthUrl}/token`,
    requested_scopes: environments.auth.scopes,
  });
};

export const pkceState = Base64.btoa(
  JSON.stringify({
    env: environments.name,
    nonce: window.crypto.randomUUID(),
    ...(environments.name === TEOD_ENV_NAME && {
      teodUrl: window.location.origin,
    }),
  })
);

export const handleLogin = async () => {
  const pkce = initiatePKCE();
  const authorizeUrl = pkce.authorizeUrl({ state: pkceState });

  if (environments.name === TEOD_ENV_NAME) {
    // js-pkce stores the code verifier in sessionStorage on the TEOD domain.
    // Since the OAuth callback lands on staging (a different domain), sessionStorage
    // is not shared. We embed the verifier in the state so staging can recover it.
    const codeVerifier = sessionStorage.getItem('pkce_code_verifier');
    const stateData = JSON.parse(Base64.atob(pkceState));
    const teodState = Base64.btoa(
      JSON.stringify({ ...stateData, cv: codeVerifier })
    );

    sessionStorage.setItem('pkce_state', teodState);

    const url = new URL(authorizeUrl);
    url.searchParams.set('state', teodState);
    window.location.replace(url.toString());
    return;
  }

  window.location.replace(authorizeUrl);
};

export const removeAuthTokens = () => {
  removeAccessToken({ path: '/', domain: environments.cookieDomain });
  removeIDToken({ path: '/', domain: environments.cookieDomain });
};
